<template>
  <div>
    <v-dialog
      v-model="dialog"
      @keydown.esc="dialog = false"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="d-flex">
          <v-btn
            rounded
            class="deepLava ml-auto"
            dark
            v-bind="attrs"
            v-on="on"
          >
            アカウントを削除する
          </v-btn>          
        </div>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">アカウントを削除しても良いですか？</span>
        </v-card-title>
        <v-card-text>
          アカウントを削除すると、すべてのデータが削除されます。
          <br>
          また、アカウントを復元することはできません。
          <br>
          本当に削除してもよろしいですか？
        </v-card-text>
        <v-card-actions>
          <v-btn
            v-if="!deleting"
            depressed
            color="error"
            @click="deleteAccount"
          >
            削除する（この操作は取り消せません）
          </v-btn>
          <v-btn
            v-else
            depressed
            color="error"
            @click="deleteAccount"
          >
            削除する（この操作は取り消せません）
            <v-progress-circular
              indeterminate
              color="white"
              size="20"
            ></v-progress-circular>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="darken-1"
            text
            @click="dialog = false"
          >
            キャンセル
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog2"
      @keydown.esc="dialog2 = false"
      persistent
      max-width="600px"
    >
      <v-card class="pa-4">
        <v-card-title>
          <v-spacer></v-spacer>
          <span>削除処理がリクエストされました。</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text class="text-center">
          通常、2営業日以内に削除処理が完了します。
          <br>
          ご不明な点がございましたら、お問い合わせください。
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            color="deepAqua"
            rounded dark
            @click="closeAndExit"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import firebase from 'firebase'
export default {
  data: () => ({
    dialog: false,
    dialog2: false,
    deleting: false,
  }),
  methods: {
    deleteAccount: async function() {
      // functionsを呼び出して、アカウント削除処理をリクエストする
      const functions = firebase.functions()
      const deleteUser = functions.httpsCallable('deleteUser')
      const res = await deleteUser()
      this.deleting = false
      if (!res) {
        console.log('error判定！')
        // エラー処理
      }
      this.dialog = false
      this.dialog2 = true
    },
    closeAndExit: function() {
      this.$store.dispatch("auth/logout");
      this.dialog2 = false
      this.$router.push({ name: 'home' })
    },
  },
}
</script>